import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-448f2b18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-md navbar-dark fixed-top bg-dark" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/logos/nesk.png",
  alt: "НЭСК",
  width: "60",
  height: "44"
}, null, -1))
const _hoisted_4 = {
  ref: "navbarTogglerRef",
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarCollapse",
  "aria-controls": "navbarCollapse",
  "aria-expanded": "false",
  "aria-label": ""
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "collapse navbar-collapse",
  id: "navbarCollapse"
}
const _hoisted_8 = { class: "navbar-nav me-auto mb-2 mb-md-0" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Главная")
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Показания")
const _hoisted_16 = {
  class: "nav-item",
  "data-toggle": "collapse",
  "data-target": ".navbar-collapse.show"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Пароль")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Выход")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "navbar-brand",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.account), 1)
          ]),
          _: 1
        }),
        _createElementVNode("button", _hoisted_4, _hoisted_6, 512),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/",
                onClick: _ctx.navbarLinkClicked
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/bill",
                onClick: _ctx.navbarLinkClicked
              }, {
                default: _withCtx(() => [
                  (_ctx.subscriberType === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Счёт на оплату "))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, " Счёт-извещение "))
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("li", _hoisted_14, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/readings",
                onClick: _ctx.navbarLinkClicked
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/password",
                onClick: _ctx.navbarLinkClicked
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode(_component_router_link, {
              to: "/exit",
              class: "nav-item nav-link",
              onClick: _ctx.navbarLinkClicked
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ])
  ]))
}